<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple"></ngx-spinner>
<app-header></app-header>
<section class="supplier_fuso_tabs mar-top-20">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item">
      <!--
        <a class="nav-link active" data-toggle="tab" href="#packageRevision" role="tab" *ngIf="userRoleID == 1"
        #approvedNav>{{'PackageRevisionTab' | translate}}</a>
      -->
        <a class="nav-link active" data-toggle="tab" href="#packageRevision" role="tab"
        #approvedNav>{{'Request For Revision' | translate}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#revisionRequested" role="tab" *ngIf="userRoleID == 1" #requestedNav>{{'Package Revision Requested' | translate}}</a>
    </li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane active" id="packageRevision" #approvedPane>
      <section class="part_search_bar">
        <div class="row no-mar-lr">
          <div class="col-md-3"></div>
          <div class="col-md-5">
            <input class="searchBar" [(ngModel)]="searchText" placeholder="{{'Please enter the package ID you like to revise' | translate}}">
          </div>
          <div class="col-md-4 pad-top-20" style="padding-left:100px;"><button class="btn btn btn-dark" (click)="getSearchData()">{{'Search' | translate}}</button></div>
        </div>
      </section>
      <section class="parts_container">
        <!-- <div class="row_title">Package Revision:</div>Parts that are Approved -->
        <div class="row">
          <div class="col-md-11">
            <table *ngIf="approvedList != null" datatable [dtOptions]="dtOptions[0]" [dtTrigger]="dtTriggerApproved"
              class="table table-white table-striped table-bordered mar-top-30 mar-btm-50">
              <thead>
                <tr>
                  <th class="text-center">{{ 'PARTNO' | translate}}</th>
                  <th class="text-center">{{'PARTNAME' | translate}}</th>
                  <th class="text-center">{{'PACKAGEID' | translate}}</th>
                  <th class="text-center">{{'DELIVERYPOINT' | translate}}</th>
                  <th class="text-center">{{'Next_Process' | translate}}</th>
                  <th class="text-center">{{'ASSIGNEDDATE' | translate}}</th>
                  <th class="text-center">{{'DUEDATE' | translate}}</th>
                  <th class="text-center">{{'Request Revision' | translate}}</th>
                </tr>
              </thead>
              <tbody>

                <tr *ngFor="let item of approvedList" class="even " [ngClass]="{rowDisabled:  item.disabled == true}">
                  <td>
                    <a href="#" [routerLink]="['/partDetails/partsInfo', item.packageId]" class="partno_column"
                      [ngClass]="{rowDisabled:  item.disabled == true}">{{
                      item.partNumber }}</a>
                  </td>
                  <td>{{ item.partName }}</td>
                  <td>{{ item.packageId }}</td>
                  <td class="text-center">{{ item.deliveryPoint }}</td>
                  <td class="text-center">{{ item.lineNumber }}</td>
                  <td class="text-center">{{ item.assignedDate | date:'yyyy-MM-dd' }}</td>
                  <td class="text-center">{{ item.dueDate | date:'yyyy-MM-dd' }}</td>
                  <td class="text-center hasLink" (click)="openModal(reasonForRequest, item)">{{'Click to Request' | translate}}</td>
                  <!-- <td class="text-center" *ngIf="userRoleID != 1 && disableROw == false">Requested for Revision</td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
    <div class="tab-pane" id="revisionRequested">
      <section class="part_search_bar"></section>
      <section class="parts_container">
        <div class="row_title">{{'Package Requested' | translate}}</div>
        <div class="row">
          <div class="col-md-12">
            <table datatable [dtOptions]="dtOptions[1]" [dtTrigger]="dtTriggerRequested" class="table table-white table-striped table-bordered">
              <thead>
                <tr>
                  <th class="text-center">{{ 'PARTNO' | translate}}</th>
                  <th class="text-center">{{'PARTNAME' | translate}}</th>
                  <th class="text-center">{{'PACKAGEID' | translate}}</th>
                  <th class="text-center">{{'DELIVERYPOINT' | translate}}</th>
                  <th class="text-center">{{'Next_Process' | translate}}</th>
                  <!-- <th class="text-center">{{'ASSIGNEDDATE' | translate}}</th>
                  <th class="text-center">{{'DUEDATE' | translate}}</th> -->
                  <th class="text-center">{{'Requested By' | translate}}</th>
                  <th class="text-center">{{'Reason for Revision' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of requestedItems" class="even">
                  <td>
                    <a href="#" [routerLink]="['/partDetails/partsInfo', item.packageId]" class="partno_column">{{
                      item.partNumber }}</a>
                  </td>
                  <td>{{ item.partName }}</td>
                  <td><a href="#" [routerLink]="['/partDetails/partsInfo', item.packageId]" class="partno_column">{{
                      item.packageId }}</a></td>
                  <td class="text-center">{{ item.deliveryPoint }}</td>
                  <td class="text-center">{{ item.lineNumber }}</td>
                  <!-- <td class="text-center">{{ item.assignedDate | date:'yyyy-MM-dd' }}</td>
                  <td class="text-center">{{ item.dueDate | date:'yyyy-MM-dd' }}</td> -->
                  <td class="text-center">{{item.userId}}</td>
                  <td class="text-center">{{item.comment}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
    <ng-template #reasonForRequest let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title">{{'Please provide appropriate reason as why you want this package to be revised' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mar-top-20">
          <div class="col-md-12">
            <textarea class="form-control" [(ngModel)]="revisionComment" (ngModelChange)="onCommentEnter($event)"
              maxlength="100"></textarea>
          </div>
          <div *ngIf="pkgCommentError == true" class="error">
            <p>
              {{'Please enter your comment for Package Revision.' | translate}}
            </p>
          </div>
          <p class="error" [hidden]="revisionComment?.length < 200">{{'You have exceeded maximum character limit' | translate}}</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="col-md-2  btn btn-dark" (click)="submitRequest()">{{'SAVE' | translate}}</button>
        <button type="button" class="col-md-2 btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
      </div>
    </ng-template>
  </div>
</section>